// Faithful PT-BR translations of the existing Spanish legal pages.
// Update the Spanish source and this translation together if legal terms change.
export const privacyPtBr = {
  seoTitle: 'Política de Privacidade | Elier Loya',
  seoDescription: 'Política de privacidade do elelier.com sobre dados pessoais, cookies, Google Analytics 4, Google Tag Manager, formulários de contato e direitos de privacidade.',
  seoKeywords: 'política de privacidade, cookies, google analytics, google tag manager, dados pessoais, elelier',
  eyebrow: 'Privacidade',
  title: 'Política de Privacidade',
  effectiveDate: 'Data de entrada em vigor: 21 de março de 2026',
  intro: 'No elelier.com, respeitamos a privacidade de quem visita este site. Esta política explica quais dados podem ser coletados, como são utilizados, quais ferramentas de terceiros participam e quais opções você tem como visitante ou possível cliente.',
  sections: [
    {
      title: '1. Responsável pelo site',
      body: ['Este site é operado por Elier Loya como portfólio profissional, vitrine de serviços e canal de contato para possíveis colaborações, consultoria, desenvolvimento de soluções digitais e projetos relacionados.'],
    },
    {
      title: '2. Quais informações podem ser coletadas',
      body: [
        'Dependendo de como você interage com o site, podem ser coletadas informações como nome, endereço de e-mail, empresa, mensagem, preferências de contato ou qualquer dado que você decida compartilhar voluntariamente por meio de formulários, agendamento ou mensagens diretas.',
        'Também podem ser coletadas informações técnicas e de uso, por exemplo: endereço IP aproximado, tipo de dispositivo, navegador, sistema operacional, idioma, páginas visitadas, tempos de interação, origem do tráfego, eventos de navegação e cookies ou identificadores semelhantes.',
      ],
    },
    {
      title: '3. Finalidades do tratamento',
      body: [
        'Os dados são utilizados para responder mensagens, avaliar oportunidades de trabalho, agendar chamadas, melhorar a experiência no site, medir o desempenho de conteúdos e serviços, detectar falhas técnicas e entender de forma agregada como a página é utilizada.',
        'Os dados pessoais não são vendidos a terceiros.',
      ],
    },
    {
      title: '4. Ferramentas e serviços de terceiros utilizados atualmente',
      body: [
        'De acordo com a configuração atual do site, o elelier.com carrega o Google Tag Manager e o Google Analytics 4. Essas ferramentas ajudam a medir visitas, navegação, desempenho geral do site e eventos de interação.',
        'O site também pode utilizar serviços de infraestrutura, hospedagem, CDN, bibliotecas de terceiros ou plataformas em nuvem relacionadas à sua operação técnica. Se futuramente o Google Cloud ou outro fornecedor for integrado para backend, formulários, automações ou armazenamento, esta política poderá ser atualizada para refletir a mudança.',
      ],
    },
    {
      title: '5. Cookies, identificadores e tecnologias semelhantes',
      body: [
        'Este site pode utilizar cookies, armazenamento local do navegador, tags de rastreamento e tecnologias semelhantes para lembrar preferências, medir o tráfego e melhorar funcionalidades.',
        'No caso do Google Analytics 4 e do Google Tag Manager, podem ser processados identificadores do navegador, dados de navegação, páginas visualizadas, interações com conteúdo, tempo no site, origem do tráfego e dados técnicos do dispositivo e navegador.',
      ],
    },
    {
      title: '6. Quando essas ferramentas são carregadas',
      body: [
        'Na implementação atual do site, o Google Tag Manager e o Google Analytics 4 são carregados ao entrar na página, ou seja, antes de um mecanismo formal de consentimento granular.',
        'Se você precisa de um modelo de conformidade mais rigoroso para determinadas jurisdições, esta implementação deverá ser complementada com um banner ou plataforma de gestão de consentimento antes que a postura de privacidade do site seja considerada suficiente.',
      ],
    },
    {
      title: '7. Base legal e consentimento',
      body: [
        'Quando exigido por lei, o tratamento se baseia em seu consentimento, na execução de medidas pré-contratuais solicitadas por você ou no interesse legítimo de operar, proteger e melhorar este site e os serviços oferecidos.',
        'Para visitantes de regiões com exigências de consentimento mais rigorosas, podem ser necessários controles adicionais antes de ativar análises não essenciais.',
      ],
    },
    {
      title: '8. Como limitar ou desativar o rastreamento',
      body: [
        'Você pode limitar ou bloquear cookies nas configurações do navegador. Também pode usar modos de navegação privada, extensões de bloqueio ou ferramentas de recusa de análises, quando disponíveis.',
        'Observe que algumas funcionalidades, métricas ou experiências do site podem ser afetadas caso o armazenamento local, scripts ou cookies sejam desativados.',
      ],
    },
    {
      title: '9. Conservação e compartilhamento de dados',
      body: [
        'As informações são mantidas apenas pelo tempo razoavelmente necessário para atender à sua solicitação, dar continuidade a contatos comerciais ou cumprir obrigações legais, fiscais, de segurança ou de prevenção a fraudes.',
        'Os dados podem ser compartilhados com fornecedores que apoiam a operação do site, sempre conforme uma necessidade razoável de serviço, segurança, hospedagem, comunicações, análises ou suporte técnico. Também podem ser divulgados se houver obrigação legal ou se isso for necessário para proteger direitos, a segurança ou a integridade do site.',
      ],
    },
    {
      title: '10. Segurança',
      body: ['Buscamos adotar medidas razoáveis para proteger as informações contra acesso não autorizado, alteração, perda ou uso indevido. Ainda assim, nenhum sistema conectado à internet pode garantir segurança absoluta.'],
    },
    {
      title: '11. Direitos de privacidade e ARCO',
      body: [
        'Você pode solicitar acesso, retificação, cancelamento ou oposição em relação aos dados pessoais que tenha compartilhado diretamente, bem como atualização ou exclusão quando cabível, sujeitos aos limites legais e operacionais aplicáveis.',
        'Se desejar exercer direitos ARCO ou fazer uma consulta sobre privacidade, utilize o e-mail indicado na seção de contato desta política e descreva claramente sua solicitação e as informações necessárias para identificar seu caso.',
      ],
    },
    {
      title: '12. Menores de idade',
      body: ['Este site não é intencionalmente direcionado a menores de idade. Se for identificado tratamento não autorizado de dados de uma pessoa menor de idade, serão feitos esforços para excluir as informações correspondentes em um prazo razoável.'],
    },
    {
      title: '13. Alterações nesta política',
      body: ['Esta política poderá ser atualizada para refletir mudanças legais, técnicas ou comerciais. A versão vigente será aquela publicada nesta página.'],
    },
    {
      title: '14. Contato',
      body: ['Se você tiver dúvidas sobre esta política, o tratamento de seus dados ou desejar exercer seus direitos de privacidade, escreva para:'],
      contactEmail: 'privacidad@elelier.com',
    },
  ],
};

export const termsPtBr = {
  seoTitle: 'Termos de Serviço | Elier Loya',
  seoDescription: 'Termos de serviço e condições de uso aplicáveis ao elelier.com, seu conteúdo, formulários e possíveis contratações.',
  seoKeywords: 'termos de serviço, condições de uso, serviços digitais, consultoria, elelier',
  eyebrow: 'Termos',
  title: 'Termos de Serviço',
  effectiveDate: 'Data de entrada em vigor: 21 de março de 2026',
  intro: 'Estes termos regem o acesso e o uso do elelier.com, assim como as interações iniciais relacionadas a serviços, conteúdos, formulários, agendamentos e materiais publicados neste site.',
  sections: [
    {
      title: '1. Aceitação dos termos',
      body: ['Ao navegar, utilizar ou interagir com este site, você concorda com estes termos. Se não concordar, deve deixar de utilizar o site.'],
    },
    {
      title: '2. Objetivo do site',
      body: ['O elelier.com funciona como portfólio profissional, vitrine comercial e informativa e canal de contato para serviços de consultoria, estratégia, automação, desenvolvimento digital, otimização de operações e projetos relacionados.'],
    },
    {
      title: '3. Uso permitido',
      body: ['Você pode utilizar o site para fins informativos, avaliação comercial ou contato legítimo. Não deve utilizá-lo para atividades ilícitas, abusivas ou fraudulentas, automação maliciosa, coleta automatizada não autorizada (scraping) ou tentativas de afetar sua segurança ou disponibilidade.'],
    },
    {
      title: '4. Informações publicadas',
      body: ['Buscamos manter as informações do site úteis e atualizadas, mas elas podem sofrer alterações ou conter erros, materiais desatualizados ou elementos em revisão. Nada neste site constitui garantia absoluta de resultados, disponibilidade permanente ou compatibilidade universal.'],
    },
    {
      title: '5. Solicitações, formulários e agendamentos',
      body: ['Se você enviar formulários, mensagens ou solicitações de agendamento, concorda em fornecer informações verdadeiras e suficientes para atender à sua demanda. O envio de uma solicitação não cria, por si só, uma relação contratual definitiva nem obriga a aceitação de um projeto.'],
    },
    {
      title: '6. Serviços profissionais',
      body: ['Qualquer serviço profissional oferecido ou discutido por meio do site estará sujeito, quando aplicável, a propostas, escopos, prazos, preços e acordos específicos em separado. Salvo acordo expresso, o conteúdo do site tem caráter apenas informativo e preliminar.'],
    },
    {
      title: '7. Propriedade intelectual',
      body: ['Os textos, designs, marcas, imagens, a estrutura do site e demais conteúdos, salvo indicação em contrário, pertencem aos respectivos titulares ou são utilizados com autorização. Não é permitida a reprodução, redistribuição ou exploração do conteúdo sem autorização prévia quando aplicável.'],
    },
    {
      title: '8. Ferramentas de terceiros',
      body: ['O site pode depender de serviços de terceiros, como infraestrutura, análises, tags, hospedagem, automação ou componentes de software, incluindo serviços do Google. A disponibilidade ou o comportamento desses serviços pode afetar determinadas funções do site, sem que isso implique responsabilidade direta por falhas externas.'],
    },
    {
      title: '9. Limitação de responsabilidade',
      body: ['Na máxima medida permitida por lei, o uso do site é por sua conta e risco. Não há garantia de que o site esteja livre de erros, interrupções ou vulnerabilidades, nem de que atenda a uma necessidade específica em todos os momentos.'],
    },
    {
      title: '10. Links externos',
      body: ['Este site pode incluir links para plataformas ou recursos externos. Esses sites operam conforme seus próprios termos e políticas, que devem ser consultados antes do uso.'],
    },
    {
      title: '11. Privacidade',
      body: ['O tratamento de dados pessoais relacionado a este site está descrito na Política de Privacidade publicada no elelier.com. Ao usar o site, você também reconhece essa política.'],
    },
    {
      title: '12. Alterações',
      body: ['Estes termos podem ser atualizados a qualquer momento para refletir mudanças legais, técnicas ou comerciais. A versão vigente será a publicada nesta página.'],
    },
    {
      title: '13. Contato',
      body: ['Para dúvidas sobre estes termos ou sobre uma possível contratação, utilize os canais de contato apresentados no site.'],
    },
  ],
};
